module.exports = __webpack_public_path__ + "img/about-m-slide.d050e4d5.jpg";